<template>
  <vue-element-loading
    :active="onLoading"
    spinner="spinner"
    color="rgba(0, 0, 0, .7)"
    background-color="rgba(255, 255, 255, .9)"
    text="กรุณารอสักครู่.."
    is-full-screen
  />
  <div class="row" v-if="canAccess">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-12">
            <div class="card-header">
              <h4 class="card-title">จัดการเกม</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
          <n-button type="info" @click="addOrUpdateGame()">เพิ่มเกม</n-button>
          <n-button
            type="default"
            class="btn-outline-info"
            @click="
              () => {
                visibleDrag = true;
              }
            "
            >จัดเรียงเกม</n-button
          >

          <a-table
            :columns="columns"
            :data-source="data"
            v-if="gameLoaded"
            :scroll="{ x: 1200 }"
          >
            <template #picture="{ record }">
              <a-image :width="25" :src="record.picture" />
            </template>

            <template #package="{ record }">
              <router-link v-bind:to="'/management/package/' + record.id">
                {{ record.package }}
              </router-link>
            </template>

            <template #status="{ record }">
              <a-tag
                :key="record.isDeleted"
                :color="record.isDeleted ? 'volcano' : 'green'"
              >
                {{ record.isDeleted ? "ไม่ใช้งาน" : "ใช้งาน" }}
              </a-tag>
            </template>
            <template #action="{ record }">
              <a href="#" @click="addOrUpdateGame(record.id)">แก้ไข</a>
            </template>
          </a-table>
        </div>
      </div>
    </div>
  </div>
  <div class="row" v-if="canAccess === false">
    <div class="col-md-12">
      <div class="card">
        <div class="card-body">
          <a-result
            status="403"
            title="403"
            sub-title="ขออภัย คุณไม่ได้รับอนุญาตให้เข้าถึงหน้านี้"
          >
            <template #extra>
              <a-button type="primary" @click="goToHome">กลับหน้าหลัก</a-button>
            </template>
          </a-result>
        </div>
      </div>
    </div>
  </div>

  <a-modal
    destroyOnClose="true"
    v-model:visible="visibleDrag"
    title="จัดเรียงเกม"
    @ok="onReorder"
    :confirm-loading="confirmDargLoading"
  >
    <draggable
      :animation="200"
      v-model="games"
      group="people"
      @start="drag = true"
      @end="drag = false"
      item-key="id"
      ghost-class="moving-card"
      class="w-full max-w-md"
    >
      <template #item="{ element }">
        <div
          class="
            p-4
            mb-3
            flex
            justify-between
            items-center
            bg-white
            shadow
            rounded-lg
            cursor-move
            border border-white
          "
          style="cursor: move"
        >
          <div class="ml-2 text-gray-700 font-semibold font-sans tracking-wide">
            <a-image
              class="w-10 h-10 rounded-full"
              :width="30"
              :src="element.picture"
            />
            &nbsp;
            {{ element.name }}
          </div>
        </div>
      </template>
    </draggable>
  </a-modal>

  <a-modal
    destroyOnClose="true"
    v-model:visible="visible"
    title="เพิ่มเกม"
    @ok="handleOk"
    :confirm-loading="confirmLoading"
  >
    <Form
      method="#"
      action="#"
      v-on:submit="onSaveGame"
      :validation-schema="schema"
      ref="myForm"
    >
      <label> รหัสเกม &nbsp; </label>
      <a-tooltip
        title="รหัสเกมจะเป็นตัวกำหนด Url เช่น mydomain.com/game/pubg"
        placement="top"
        arrow-point-at-center
      >
        <QuestionCircleTwoTone
          twoToneColor="#108ee9"
          style="display: inline-grid"
        />
      </a-tooltip>

      <vee-input
        name="code"
        type="text"
        :value="code"
        placeholder="Enter code"
      />

      <vee-input
        label="ชื่อเกม"
        name="name"
        type="text"
        :value="name"
        placeholder="Enter name"
      />
      <vee-input
        label="รายละเอียด"
        name="desc"
        type="text"
        :value="desc"
        placeholder="Enter description"
      />
      <label>Qms Game Id</label>
      <a-select
        placeholder="เลือก Qms game id"
        v-model:value="selects.qmsGame"
        style="width: 100%; margin-bottom: 15px"
        :filter-option="false"
        :options="selects.qmsGames"
      >
      </a-select>
      <p>รูปโลโก้ (แนะนำขนาดรูป 228x228)</p>
      <a-upload
        v-model:file-list="fileList"
        :openFileDialogOnClick="fileList.length < 1"
        name="file"
        :multiple="false"
        accept="image/*"
        :action="url + '/games/uploadlogo'"
        :headers="headers"
        @change="handleChange"
      >
        <a-button>
          <upload-outlined></upload-outlined>
          Click to Upload
        </a-button>
      </a-upload>
      <br />
      <div class="row">
        <div class="col-md-8">
          <label> Custom Field 1 &nbsp; </label>
          <a-tooltip
            title="Custom Field ที่เปิดใช้งานจะแสดงผลที่หน้าเลือก Package"
            placement="top"
            arrow-point-at-center
          >
            <QuestionCircleTwoTone
              twoToneColor="#108ee9"
              style="display: inline-grid"
            />
          </a-tooltip>
          <vee-input
            name="field1"
            type="text"
            :value="field1"
            placeholder="Enter field name"
          />
        </div>
        <div class="col-md-4">
          <a-switch
            name="field1isactived"
            v-model:checked="field1IsActived"
            @change="onSwitchChange(field1IsActived, 'field1isactived')"
            class="switch"
          >
            <template #checkedChildren>เปิดใช้งาน</template>
            <template #unCheckedChildren>ปิดใช้งาน</template>
          </a-switch>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <vee-input
            label="Custom Field 2"
            name="field2"
            type="text"
            :value="field2"
            placeholder="Enter field name"
          />
        </div>
        <div class="col-md-4">
          <a-switch
            v-model:checked="field2IsActived"
            name="field2isactived"
            @change="onSwitchChange(field2IsActived, 'field2isactived')"
            class="switch"
          >
            <template #checkedChildren>เปิดใช้งาน</template>
            <template #unCheckedChildren>ปิดใช้งาน</template>
          </a-switch>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <vee-input
            label="Custom Field 3"
            name="field3"
            type="text"
            :value="field3"
            placeholder="Enter field name"
          />
        </div>
        <div class="col-md-4">
          <a-switch
            v-model:checked="field3IsActived"
            name="field3isactived"
            @change="onSwitchChange(field3IsActived, 'field3isactived')"
            class="switch"
          >
            <template #checkedChildren>เปิดใช้งาน</template>
            <template #unCheckedChildren>ปิดใช้งาน</template>
          </a-switch>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <vee-input
            label="Custom Field 4"
            name="field4"
            type="text"
            :value="field4"
            placeholder="Enter field name"
          />
        </div>
        <div class="col-md-4">
          <a-switch
            v-model:checked="field4IsActived"
            name="field4isactived"
            @change="onSwitchChange(field4IsActived, 'field4isactived')"
            class="switch"
          >
            <template #checkedChildren>เปิดใช้งาน</template>
            <template #unCheckedChildren>ปิดใช้งาน</template>
          </a-switch>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8">
          <vee-input
            label="Custom Field 5"
            name="field5"
            type="text"
            :value="field5"
            placeholder="Enter field name"
          />
        </div>
        <div class="col-md-4">
          <a-switch
            v-model:checked="field5IsActived"
            name="field5isactived"
            @change="onSwitchChange(field5IsActived, 'field5isactived')"
            class="switch"
          >
            <template #checkedChildren>เปิดใช้งาน</template>
            <template #unCheckedChildren>ปิดใช้งาน</template>
          </a-switch>
        </div>
      </div>

      <br />
      <div class="form-group">
        <checkbox v-model="checked" @change="onIsActiveChange" name="isactive"
          >ใช้งาน</checkbox
        >
      </div>
      <button ref="submit" style="display: none">Submit</button>
    </Form>
  </a-modal>
</template>

<script>
let url = "http://18.142.153.80:9999/romons.game/api";
import * as gameservice from "../../../services/game";
import * as configuration from "../../../middleware/configuration";
import { message } from "ant-design-vue";
import { UploadOutlined, QuestionCircleTwoTone } from "@ant-design/icons-vue";
import { ref } from "vue";
import { VeeInput, Checkbox } from "@/components";
import * as Yup from "yup";
import { Form } from "vee-validate";
import draggable from "vuedraggable";
import VueElementLoading from "vue-element-loading";

const columns = [
  {
    title: "No",
    dataIndex: "no",
    key: "no",
    width: 65,
  },
  {
    title: "รหัสเกม",
    dataIndex: "code",
    key: "code",
    width: 120,
  },
  {
    title: "ชื่อเกม",
    dataIndex: "name",
    key: "name",
    width: 250,
  },
  {
    title: "คำอธิบาย",
    dataIndex: "desc",
    key: "desc",
  },
  {
    title: "QMS Game Id",
    dataIndex: "qmsGameId",
    key: "qmsGameId",
    align: 'center'
  },
  {
    title: "รูปโลโก้",
    key: "picture",
    slots: { customRender: "picture" },
    width: 85,
  },
  {
    title: "จำนวนแพ็กเกจ",
    key: "package",
    align: "center",
    slots: { customRender: "package" },
    width: 120,
  },
  {
    title: "สถานะ",
    key: "status",
    align: "center",
    slots: { customRender: "status" },
    width: 100,
  },
  {
    title: "Action",
    key: "id",
    align: "center",
    slots: { customRender: "action" },
    width: 85,
  },
];
export default {
  components: {
    UploadOutlined,
    QuestionCircleTwoTone,
    Checkbox,
    Form,
    VeeInput,
    draggable,
    VueElementLoading
  },
  methods: {
    async getGames() {
      try {
        let res = await gameservice.get("games/master");
        this.data = res.data;
        this.games = res.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.gameLoaded = true;
      }
    },
    async getQmsGames() {
      this.onLoading = true;
      try {
        let res = await gameservice.get("games/qmsgame");
        this.selects.qmsGames = res.data.map((x) => {
          return { value: x.game_id, label: `${x.game_id} - ${x.game_sdesc}` };
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.onLoading = false;
      }
    },
    async addOrUpdateGame(id = 0) {
      if (id !== 0) {
        let data = this.data.find((x) => x.id === id);
        this.id = id;
        this.code = data.code;
        this.name = data.name;
        this.desc = data.desc;
        this.selects.qmsGame = data.qmsGameId;
        this.picture = data.picture;
        this.checked = !data.isDeleted;
        this.field1 = data.field1;
        this.field1IsActived = data.field1IsActived;
        this.field2 = data.field2;
        this.field2IsActived = data.field2IsActived;
        this.field3 = data.field3;
        this.field3IsActived = data.field3IsActived;
        this.field4 = data.field4;
        this.field4IsActived = data.field4IsActived;
        this.field5 = data.field5;
        this.field5IsActived = data.field5IsActived;
      } else {
        this.id = id;
        this.code = "";
        this.name = "";
        this.desc = "";
        this.selects.qmsGame = null;
        this.picture = "";
        this.checked = true;
        this.field1 = "";
        this.field1IsActived = false;
        this.field2 = "";
        this.field2IsActived = false;
        this.field3 = "";
        this.field3IsActived = false;
        this.field4 = "";
        this.field4IsActived = false;
        this.field5 = "";
        this.field5IsActived = false;
      }
      await this.getQmsGames();
      this.visible = true;
    },
    handleOk(e) {
      this.$refs.submit.click();
    },
    async onSaveGame(values) {
      this.confirmLoading = true;
      var image = this.fileList.shift();
      if (
        this.id === 0 &&
        this.data.filter((x) => x.code === values.code).length > 0
      ) {
        message.error(`รหัสเกม ${values.code} ซ้ำ`);
        this.confirmLoading = false;
        return;
      } else if (
        this.data.filter((x) => x.code === values.code && this.id !== x.id)
          .length > 0
      ) {
        this.confirmLoading = false;
        message.error(`รหัสเกม ${values.code} ซ้ำ`);
        return;
      }
      var data = {
        id: this.id,
        code: values.code,
        name: values.name,
        desc: values.desc,
        qmsGameId: this.selects.qmsGame,
        picture: image !== undefined ? image.response.url : this.picture,
        isDeleted: !this.checked,
        field1: values.field1,
        field1IsActived: this.field1IsActived,
        field2: values.field2,
        field2IsActived: this.field2IsActived,
        field3: values.field3,
        field3IsActived: this.field3IsActived,
        field4: values.field4,
        field4IsActived: this.field4IsActived,
        field5: values.field5,
        field5IsActived: this.field5IsActived,
      };

      try {
        let res = await gameservice.save(data);
        if (res) {
          this.visible = false;
          message.success(`บันทึก ${data.name} สำเร็จ`);
        }
      } catch (error) {
        message.error("ไม่สามารถบันทึกข้อมูลได้ กรุณาลองอีกครั้ง");
      } finally {
        await this.getGames();
        this.confirmLoading = false;
      }
    },
    async onReorder() {
      this.confirmDargLoading = false;

      let games = this.games;

      let data = [];

      games.forEach((g, i) => {
        g.no = i + 1;
        data.push({
          id: g.id,
          no: g.no,
        });
      });

      try {
        let res = await gameservice.reorder(data);
        if (res) {
          this.visibleDrag = false;
          message.success(`จัดเรียงเกมสำเร็จ`);
        }
      } catch (error) {
        message.error(`จัดเรียงเกมไม่สำเร็จ กรุณาลองอีกครั้ง`);
      } finally {
        await this.getGames();
        this.confirmDargLoading = false;
      }
    },
    onIsActiveChange(e) {
      this.$refs.myForm.setValues({
        isactive: e.target.checked,
      });
      this.checked = e.target.checked;
    },
    goToHome() {
      this.$router.push("/game");
    },
    onSwitchChange(checked, name) {
      this.$refs.myForm.setValues({
        [name]: checked,
      });
    },
  },
  data() {
    return {
      onLoading: false,
      drag: false,
      visibleDrag: false,
      games: [],
      data: [],
      gameLoaded: false,
      columns: columns,
      visible: false,
      canAccess: null,
      selects: {
        qmsGame: null,
        qmsGames: [],
      },
      id: 0,
      code: "",
      name: "",
      desc: "",
      picture: "",
      checked: true,
      url: url,
      confirmLoading: false,
      confirmDargLoading: false,
      field1: "",
      field2: "",
      field3: "",
      field4: "",
      field5: "",
      field1IsActived: false,
      field2IsActived: false,
      field3IsActived: false,
      field4IsActived: false,
      field5IsActived: false,
    };
  },
  async beforeMount() {
    this.uid = await configuration.getUid();
    let user = await configuration.getIdTokenResult();
    this.role = user.claims?.role || this.role;
    if (this.role === "admin" || this.role === "manager") {
      await this.getGames();
      this.canAccess = true;
    } else {
      this.canAccess = false;
    }
  },
  setup() {
    const schema = Yup.object().shape({
      code: Yup.string().required().label("The Code"),
      name: Yup.string().required().label("The Name"),
      desc: Yup.string().label("The Desc"),
      isactive: Yup.bool().label("The isactive"),
      field1isactived: Yup.bool(),
      field1: Yup.string()
        .nullable(true)
        .when("field1isactived", {
          is: true,
          then: Yup.string().required().label("The custom field"),
        })
        .transform((_, val) => (val === val ? val : null)),
      field2isactived: Yup.bool(),
      field2: Yup.string()
        .nullable(true)
        .when("field2isactived", {
          is: true,
          then: Yup.string().required().label("The custom field"),
        })
        .transform((_, val) => (val === val ? val : null)),
      field3isactived: Yup.bool(),
      field3: Yup.string()
        .nullable(true)
        .when("field3isactived", {
          is: true,
          then: Yup.string().required().label("The custom field"),
        })
        .transform((_, val) => (val === val ? val : null)),
      field4isactived: Yup.bool(),
      field4: Yup.string()
        .nullable(true)
        .when("field4isactived", {
          is: true,
          then: Yup.string().required().label("The custom field"),
        }),
      field5isactived: Yup.bool(),
      field5: Yup.string()
        .nullable(true)
        .when("field5isactived", {
          is: true,
          then: Yup.string().required().label("The custom field"),
        })
        .transform((_, val) => (val === val ? val : null)),
    });
    const handleChange = (info) => {
      if (info.file.status !== "uploading") {
        console.log(info.file, info.fileList);
      }

      if (info.file.status === "done") {
        message.success(`${info.file.name} file uploaded successfully`);
      } else if (info.file.status === "error") {
        message.error(`${info.file.name} file upload failed.`);
      }
    };

    const fileList = ref([]);
    return {
      schema,
      fileList,
      handleChange,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "https://unpkg.com/tailwindcss@1.9.6/dist/tailwind.min.css";

.switch {
  margin-top: 39px;
}
.list-group {
  display: -ms-flexbox;
  display: -webkit-box;
  display: flex;
  -ms-flex-direction: column;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.25rem;
}
.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.125);
}
.moving-card {
  opacity: 0.5;
  background: #f7fafc;
  border: 1px solid #4299e1;
}
</style>